import { createContext } from 'react'

export const INITIAL_LAYOUT_STATE: {
  headerHeight: number
  footerHeight: number
} = {
  headerHeight: 0,
  footerHeight: 0,
}

export interface LayoutProps {
  headerHeight: number
  footerHeight: number
}

export const LayoutContext = createContext<LayoutProps>(INITIAL_LAYOUT_STATE)
